import { Component, OnInit, inject } from '@angular/core';
import {TranslationService} from '../../core/services/translation.service';
import {HupSubscriptionsService} from '../../data/services/hup-subscriptions.service';
import {ActivatedRoute} from '@angular/router';
import {HupSubscription} from '../../data/models/subscription.model';
import {NavigationCommand, NavigationService} from "../../data/services/navigation.service";
import {LoginService} from "../../core/components/login/login.service";
import {ConfigService} from "../../core/services/config.service";
import {LoadingSpinnerComponent} from "../../core/components/loading-spinner/loading-spinner.component";
import { DatePipe } from "@angular/common";
import {MatCard, MatCardActions, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {HouseNoPipe} from "../../core/pipes/houseno.pipe";
import {MatButton} from "@angular/material/button";
import {ApplyIfNotEmptyDirective} from "../../core/directives/apply-if-not-empty.directive";

@Component({
  selector: 'app-hup-subscription',
  templateUrl: './hup-subscription.component.html',
  styleUrls: ['./hup-subscription.component.scss'],
  imports: [
    LoadingSpinnerComponent,
    MatCard,
    MatCardTitle,
    MatCardSubtitle,
    DatePipe,
    HouseNoPipe,
    MatCardActions,
    MatButton,
    ApplyIfNotEmptyDirective
  ],
  providers: [
    DatePipe
  ],
  standalone: true
})
export class HupSubscriptionComponent implements OnInit {
  translationService = inject(TranslationService);
  private hupSubscriptionsService = inject(HupSubscriptionsService);
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);
  private loginService = inject(LoginService);
  private configService = inject(ConfigService);

  subs: HupSubscription[] = [];
  isLoading: boolean;
  errorsArr: string[] = [];
  aggregateSubscription: boolean = false;
  showSubscriptionStatus: boolean = false;

  constructor() {
    this.isLoading = true;
    this.aggregateSubscription = this.configService.getConfig('subscription.aggregateSequelAndCombi')?.asBoolean();
    this.showSubscriptionStatus = this.configService.getConfig('subscription.showStatus')?.asBoolean();
  }

  ngOnInit(): void {
    this.loginService.getAuthData().subscribe((authData) => {
      this.isLoading = true;
      if (!!authData && (authData.token !== null)) {
        if (this.aggregateSubscription) {
          this.hupSubscriptionsService.getSubscriptionsGroupedAlsoTerminated().subscribe(subs => {
            this.handleSubscriptions(subs);
          }, error => {
            this.isLoading = false;
            this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
          });
        } else {
          this.hupSubscriptionsService.getSubscriptionsAlsoTerminated().subscribe(subs => {
            this.handleSubscriptions(subs);
          }, error => {
            this.isLoading = false;
            this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
          });
        }
      } else {
        // Fehler beim Laden der Abos!
        this.isLoading = false;
        this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
      }
    });
  }

  private handleSubscriptions(subs: HupSubscription[]) {
    this.isLoading = false;
    this.subs = subs;
    if (subs && subs.length === 1) {
      this.aboDetails(this.subs[0]);
    }
  }

  cancelOrder(sub): void {
    alert('cancelOrder');
  }

  // Unterscheiden sich die irgendwie?
  // inProcessDetails(sub): void {
  //   this.router.navigate([+sub.webId + '/' + +sub.backendId], {relativeTo: this.route});
  // }
  aboDetails(sub): void {
    this.navigationService.navigateTo(NavigationCommand.SUBSCRIPTION, [sub.webId, sub.backendId]);
  }

  // changeAboDetails(sub): void {
  //   alert('changeAboDetails');
  // }

}
